module.exports = "#report-configuration .header {\n  height: 160px;\n  min-height: 160px;\n  max-height: 160px; }\n  #report-configuration .header .save-button {\n    margin-left: 24px; }\n  #report-configuration .content .md-card {\n  background: white;\n  border-radius: 8px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/configurations/report-configuration/report-configuration.component.scss
// module id = ./src/app/main/content/pages/management/configurations/report-configuration/report-configuration.component.scss
// module chunks = main